// src/StripePaymentForm/PaymentSuccessDialog.jsx
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@material-ui/core';

function PaymentSuccessDialog({ open, onClose, loading }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='xs'
      fullWidth
      PaperProps={{
        style: {
          background: 'linear-gradient(145deg, #2a2a2a, #1f1f1f)',
          border: '1px solid #4a4a4a',
          boxShadow: '0 0 30px rgba(100, 100, 255, 0.3)'
        }
      }}>
      <DialogTitle>
        <Typography variant='h6' style={{ fontWeight: 600, color: '#e5e5e5' }}>
          Payment Successful
        </Typography>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
            <CircularProgress style={{ color: '#8484ff' }} />
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
              <CheckCircleIcon style={{ fontSize: 64, color: '#6464ff', filter: 'drop-shadow(0 0 10px rgba(100, 100, 255, 0.5))' }} />
            </div>
            <Typography align='center' style={{ color: '#d0d0d0', fontSize: '1rem' }}>
              Thank you! Your payment was processed successfully.
            </Typography>
            <Typography align='center' style={{ color: '#909090', fontSize: '0.9rem', marginTop: 8 }}>
              You will receive a confirmation email shortly.
            </Typography>
          </>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions style={{ justifyContent: 'center', padding: '16px' }}>
          <Button
            variant='contained'
            onClick={onClose}
            style={{
              background: 'linear-gradient(135deg, #6464ff, #8484ff)',
              color: '#fff',
              padding: '8px 32px',
              fontWeight: 600,
              boxShadow: '0 0 16px rgba(100, 100, 255, 0.4)'
            }}>
            OK
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default PaymentSuccessDialog;
